/**
 * Text Media Boxed - Video Play Handler
 * Clicking the thumbnail replaces it with an autoplay embed iframe.
 * Supports YouTube and Vimeo URLs.
 */

function getEmbedUrl(url) {
  // YouTube
  const ytMatch = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  if (ytMatch) {
    return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&rel=0`;
  }

  // Vimeo
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
  }

  return null;
}

document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.tmb-thumbnail[data-video-url]');

  if (!thumbnails.length) return;

  thumbnails.forEach(function (thumbnail) {
    function activate() {
      const videoUrl = thumbnail.dataset.videoUrl;
      const embedUrl = getEmbedUrl(videoUrl);

      if (!embedUrl) return;

      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.className = 'tmb-iframe';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('title', 'Video player');

      thumbnail.innerHTML = '';
      thumbnail.appendChild(iframe);
      thumbnail.removeAttribute('role');
      thumbnail.removeAttribute('tabindex');
    }

    thumbnail.addEventListener('click', activate);

    thumbnail.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activate();
      }
    });
  });
});
